import type { OrderInfo } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { gql } from '@apollo/client'

export interface UnapplyPromocodeMutation {
  updated: OrderInfo
}

export interface UnapplyPromocodeMutationVariables {
  order_id: GQL_ID
  promocode_id: GQL_ID
}

export const GQL_MUTATION_UNAPPLY_PROMOCODE = gql`
  mutation($order_id: ID!, $promocode_id: ID!) {
    unapplyPromocode(order_id: $order_id, promocode_id: $promocode_id) {
      updated: order {
        id
        promocode {
          id
          code
        }
      }
    }
  }
`
